import { isPro, isClient } from '~~/utils/index'

export default (request: any, options: IObject, response: IObject) => {
  const config = useRuntimeConfig()
  if (!isPro(config.public.env.NODE_ENV) && !isClient()) {
    import('./logger.config').then(({ responseLog }) => {
      responseLog.info(
        `[Response Info]：${JSON.stringify({
          request: `${request}`,
          method: options.method,
          response: response._data,
        })}`,
      )
    })
  }
}
